// extracted by mini-css-extract-plugin
var _1 = "u256W";
var _2 = "M6p9W";
export { _1 as "base", _2 as "tabs" }
